import "./SectionReport.less";

import { PDFViewer } from "@react-pdf/renderer";
import { Spin } from "antd";
import * as QueryString from "query-string";
import React from "react";
import { Redirect } from "react-router-dom";

import { MetadataApi, OrderedEntryGroupApi, OrderedListingGroupApi, SectionVersionApi } from "lib/api";
import { CancellationToken } from "lib/api/base";
import { IBaseProps, IReportProps } from "lib/data/interfaces";
import { SectionVersion } from "lib/data/model";
import { StateService } from "lib/services";

import { RedirectButton } from "components/general";
import { SectionPage } from "components/pages";
import { PDF } from "./PDF";


interface ISectionReportProps extends IReportProps, IBaseProps {

}

interface ISectionReportState {
	isLoading: boolean;
	isLoaded: boolean;
	errorMessage?: string;
	isNavigatingHome: boolean;
}

export class SectionReport extends React.Component<ISectionReportProps, ISectionReportState> {

	private apiCancellationToken: CancellationToken = new CancellationToken();


	private sectionId!: number;
	private version!: SectionVersion;

	constructor(props: ISectionReportProps) {

		super(props);

		this.state = {
			isLoading: true,
			isLoaded: false,
			isNavigatingHome: false
		};
	}

	public componentWillMount() {

		// Parse Provided Query String
		const sectionId = QueryString.parse(this.props.queryString, { parseNumbers: true }).sectionId;

		// Check Section ID
		if (sectionId !== undefined && sectionId !== null && typeof sectionId === "number") {

			// Set Section ID
			this.sectionId = sectionId;

			// Process Section
			this.processSection(sectionId);
		}
		else {

			// Indicate Navigating Home
			StateService.setCancelableState(() => this.setState({ isNavigatingHome: true }), this.apiCancellationToken);
		}
	}

	public componentWillReceiveProps(newProps: ISectionReportProps) {

		// Indicate Report Is Loading
		StateService.setCancelableState(() => this.setState({ isLoading: true, isLoaded: false, errorMessage: undefined }), this.apiCancellationToken);

		// Parse Provided Query String
		const sectionId = QueryString.parse(newProps.queryString, { parseNumbers: true }).sectionId;

		// Check Section ID
		if (sectionId !== undefined && sectionId !== null && typeof sectionId === "number") {

			// Set Section ID
			this.sectionId = sectionId;

			// Process Section
			this.processSection(sectionId);
		}
		else {

			// Indicate Navigating Home
			StateService.setCancelableState(() => this.setState({ isNavigatingHome: true }), this.apiCancellationToken);
		}
	}

	public componentWillUpdate(_nextProps: ISectionReportProps, nextState: ISectionReportState) {

		// Check If Is Already Navigating
		if (nextState.isNavigatingHome) {

			// Reset Navigation
			StateService.setCancelableState(() => this.setState({ isNavigatingHome: false }), this.apiCancellationToken);
		}
	}

	public componentWillUnmount() {

		// Cancel Outstanding API Calls
		this.apiCancellationToken.cancel();
	}

	public render() {

		const ReportWrapper: React.FunctionComponent = (props) => (

			<section className="section-tree-report">

				<div className="report-actions">
					<RedirectButton
						icon="left"
						type="ghost"
						href={`${SectionPage.BasePath}/${this.sectionId}`}
						push={false}
					>
						Return
					</RedirectButton>
				</div>

				{props.children}

			</section>
		);

		// Check For 'Other' State
		if (this.state.isNavigatingHome) {

			return <Redirect to="/" push={false} />;
		}
		else if (this.state.isLoading) {

			// Indicate Report Is Loading
			return (

				<ReportWrapper>
					<Spin className="report-loader" />
				</ReportWrapper>
			);
		}
		else if (!this.state.isLoaded) {

			// Check For Error Message
			if (this.state.errorMessage !== undefined) {

				// Indicate Report Has Known Error
				return (

					<ReportWrapper>
						<span>Error: {this.state.errorMessage}</span>
					</ReportWrapper>
				);
			}

			// Indicate Report Has Unknown Error
			return (

				<ReportWrapper>
					<span>Unknown Error</span>
				</ReportWrapper>
			);
		}

		// Render Report Viewer
		return (

			<ReportWrapper>

				<PDFViewer className="report-viewer">
					<PDF section={this.version} />
				</PDFViewer>

			</ReportWrapper>
		);
	}

	private processSection = async (sectionId: number) => {

		// Request Section
		const published = await SectionVersionApi.getPublishedById(sectionId);

		// Check Section
		if (published !== undefined) {

			// Get Metadata
			published.metadata = await MetadataApi.getAll(sectionId, published, undefined);

			// Get Components
			published.entryGroups = await OrderedEntryGroupApi.getAll(sectionId, published, true);
			published.listingGroups = await OrderedListingGroupApi.getAll(sectionId, published, true);

			// Store Entire Version
			this.version = published;

			// Indicate Report Successfully Loaded
			StateService.setCancelableState(() => this.setState({ isLoading: false, isLoaded: true, errorMessage: undefined }), this.apiCancellationToken);
		}
		else {

			// Indicate Report Failed To Load
			StateService.setCancelableState(() => this.setState({ isLoading: false, isLoaded: false, errorMessage: "Error Retrieving Record(s)" }), this.apiCancellationToken);
		}
	}
}
